import { parseAsInteger, useQueryState } from 'nuqs';
import { createContext, useMemo, useState } from 'react';

export interface TSitesContext {
  page: number;
  setPage: (page: number) => Promise<URLSearchParams>;
  activeFilters: Partial<Record<'name' | 'city', string>>;
  setActiveFilters: (filters: Partial<Record<'name' | 'city', string>>) => void;
}

export const SitesContext = createContext<TSitesContext>({} as TSitesContext);

export type TSitesInitialData = Omit<
  TSitesContext,
  'setPage' | 'setActiveFilters'
>;

export const QueryStateKey = 's_page';

export function SitesProvider({ children }: { children: React.ReactNode }) {
  const [ page, setPage ] = useQueryState(
    QueryStateKey,
    parseAsInteger.withDefault(1).withOptions({
      history: 'push',
    }),
  );
  const [ activeFilters, setActiveFilters ] = useState<
    Partial<Record<'name' | 'city', string>>
  >({});

  const value = useMemo(() => {
    return { page, setPage, activeFilters, setActiveFilters };
  }, [ page, setPage, activeFilters, setActiveFilters ]);

  return (
    <SitesContext.Provider value={ value }>{ children }</SitesContext.Provider>
  );
}
